var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vue-lucky-wheel",
    style: _vm.style
  }, [_c('div', {
    staticClass: "vue-lucky-wheel-main",
    style: _vm.mainStyle
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "vue-lucky-wheel-button",
    on: {
      "click": _vm.getPrize
    }
  }, [_vm._t("button")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };